import React from "react"
import ReactDOM from "react-dom"
import MerchantPageHero from "./merchant-page-hero"

export default class MerchantPageHeroModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.currentPageJson = elem.dataset.currentPageJson && JSON.parse(elem.dataset.currentPageJson)
    self.merchantPageLabels = elem.dataset.merchantPageLabels && JSON.parse(elem.dataset.merchantPageLabels)
    self.categoriesText = elem.dataset.categoriesText && JSON.parse(elem.dataset.categoriesText)
    self.weekdays = elem.dataset.weekdays && JSON.parse(elem.dataset.weekdays)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(
      <MerchantPageHero
        {...self.currentPageJson}
        merchantPageLabels={self.merchantPageLabels}
        categoriesText={self.categoriesText}
        weekdays={self.weekdays}
      />,
      self.elem,
    )
  }
}
